import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { clearReturnPath, peekReturnPath } from "../auth/oauth";

export default function AuthCallbackPage() {
  const { completeSignIn } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oauthError = params.get("error_description") || params.get("error");
    const code = params.get("code");
    const state = params.get("state");
    const returnTo = peekReturnPath();

    if (oauthError) {
      navigate(`/login?error=${encodeURIComponent(oauthError)}`, { replace: true });
      return;
    }
    if (!code || !state) {
      navigate("/login?error=" + encodeURIComponent("Sign-in did not return a code."), { replace: true });
      return;
    }

    let cancelled = false;
    completeSignIn({ code, state })
      .then(() => {
        if (cancelled) return;
        clearReturnPath();
        navigate(returnTo, { replace: true });
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err?.message || "Sign-in failed.");
        }
      });
    return () => {
      cancelled = true;
    };
  }, [completeSignIn, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 px-4">
      <div className="max-w-md text-center">
        {error ? (
          <>
            <p className="text-red-700 dark:text-red-300">{error}</p>
            <a href="/login" className="inline-block mt-4 text-sepm-primary font-semibold">
              Back to sign in
            </a>
          </>
        ) : (
          <p className="text-gray-600 dark:text-gray-300">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
